import React from "react";
import { useState, useEffect } from "react";
import PageBanner from "../../components/common/PageBanner";
import BgImage from "../../Assets/Images/Rental/rental-page-banner.webp";
import SectionHeading from "../../components/common/SectionHeading";
import axios from "axios";

const Membership = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 11,
    hours: 12,
    minutes: 13,
    seconds: 14,
  });
  const [sectionHeadingData, setSectionHeadingData] = useState({});
  const [loading, setLoading] = useState(true);
  const [bannerData, setBannerData] = useState({});
  const [bannerloading, setBannerLoading] = useState(false);

  const getBannerData = () => {
    setBannerLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/page-banner/get-banner/membership`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setBannerData(response.data);
        setBannerLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setBannerLoading(false);
      });
  };

  useEffect(() => {
    getBannerData();
  }, []);

  const getData = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/membership/get-membership-data`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        const membershipData = response?.data?.membership;
        setSectionHeadingData(membershipData);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const launchDate = new Date("2024-12-31T23:59:59").getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const difference = launchDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {bannerloading ? (
        <BannerSkeleton />
      ) : (
        <PageBanner
          title={bannerData.title}
          subtitle={bannerData.subtitle}
          background={bannerData.bgImage}
        />
      )}

      {loading ? (
        <div className="px-6 py-12 space-y-4">
          <SkeletonBox width="w-3/4" height="h-10" />
          <SkeletonBox width="w-full" height="h-6" />
          <SkeletonBox width="w-5/6" height="h-6" />
        </div>
      ) : (
        <SectionHeading
          title={sectionHeadingData?.heading}
          subtitle={sectionHeadingData?.subHeading}
          containerClassName={"py-4 md:py-8 lg:py-12 my-4"}
        />
      )}

      {/* Coming Soon Section */}
      <div className="relative overflow-hidden bg-white">
        {/* Animated Background Elements (optional, you may tone down colors for white bg) */}
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
          <div className="absolute top-1/3 right-1/4 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
          <div className="absolute bottom-1/4 left-1/3 w-72 h-72 bg-cyan-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-4000"></div>
        </div>

        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/* Main Coming Soon Text */}
            <div className="mb-12">
              <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold text-gray-900 mb-6 tracking-tight">
                COMING
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500 mt-2">
                  SOON
                </span>
              </h2>
              <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
                We're crafting something extraordinary for our members. Get
                ready for an unparalleled sports experience!
              </p>
            </div>

            {/* Countdown Timer */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-2xl mx-auto mb-12">
              {Object.entries(timeLeft).map(([unit, value]) => (
                <div key={unit} className="text-center">
                  <div className="bg-gray-100 rounded-2xl p-4 md:p-6 border border-gray-200 shadow-lg">
                    <div className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-2">
                      {value.toString().padStart(2, "0")}
                    </div>
                    <div className="text-sm md:text-base font-semibold text-gray-500 uppercase tracking-wider">
                      {unit}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Progress Bar */}
            <div className="max-w-2xl mx-auto mb-12">
              <div className="flex justify-between text-sm text-gray-500 mb-2">
                <span>Development Progress</span>
                <span>85%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3">
                <div
                  className="bg-gradient-to-r from-green-400 to-blue-500 h-3 rounded-full transition-all duration-1000 ease-out"
                  style={{ width: "85%" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Membership;
const SkeletonBox = ({ width = "w-full", height = "h-6", className = "" }) => {
  return (
    <div
      className={`bg-gray-300/40 animate-pulse rounded-md ${width} ${height} ${className}`}
    ></div>
  );
};

// import React from "react";
// import PageBanner from "../../components/common/PageBanner";
// import BgImage from "../../Assets/Images/Rental/rental-page-banner.png";
// import SectionHeading from "../../components/common/SectionHeading";
// import SportsStrikePricing from "../../components/User/Membership/SportsStrikePricing";

// const Membership = () => {
//   return (
//     <div>
//       <PageBanner title={"MEMBERSHIP"} background={BgImage} />
//       <SectionHeading
//         title={"Join the Strike & Shorts Family"}
//         subtitle={
//           "Enjoy exclusive access to open play, priority registration for leagues and programs, and special discounts on rentals and concessions. Become a member today and make Silverbacks Indoor your home for year-round sports and community"
//         }
//         containerClassName={"py-4 md:py-8 lg:py-12"}
//       />
//       <SportsStrikePricing />
//     </div>
//   );
// };

// export default Membership;
const BannerSkeleton = () => {
  return (
    <div className="relative w-full h-36 sm:h-52 md:h-60 lg:h-80 px-4 md:px-8 lg:px-12 animate-pulse">
      <div className="absolute inset-0 bg-gray-300/50"></div>

      <div className="relative z-10 flex flex-col justify-center h-full">
        <div className="h-8 w-40 bg-gray-400/60 rounded-md mb-4"></div>
        <div className="h-4 w-64 bg-gray-400/50 rounded-md"></div>
      </div>
    </div>
  );
};
